<div class="layout-container">
	<div class="mdc-layout-grid__inner center gap-0">
		<div class="mdc-layout-grid__cell--span-12">
			<img [src]="'/assets/images/payment/Group 45986.png' | s3Image" />
		</div>

		<div class="mdc-layout-grid__cell--span-12 my-3">
			<p class="n119 fs-20px fw-500 mb-0">{{ locale.translations['ads']['ad']['n633'] }}</p>
			<p class="n120 fg-grey mb-0 mt-1">{{ locale.translations['ads']['ad']['n634'] }}</p>
			<p class="n121 mb-0 mt-1" *ngIf="!auth.user()">{{ locale.translations['place-ad']['place-ad-success']['n121'] }}</p>
		</div>

		<div class="mdc-layout-grid__cell--span-12 mb-3">
			<div class="box bg-lightest-grey p-3">
				<p class="text-start fw-500 fs-14px mb-2" [ngClass]="{ 'text-end': locale.lang !== 'en' }">{{ locale.translations['ads']['ad']['n635'] }}</p>
				<ul class="list-unstyled fg-grey px-0 mb-0">
					<li class="mb-2">
						<mat-icon class="fs-20px align-middle fg-grey" [ngClass]="{ 'text-end': locale.lang !== 'en', 'text-start': locale.lang === 'en' }">
							check
						</mat-icon>
						<span class="fs-14px">{{ locale.translations['payment']['n590'] }}</span>
						<img
							[src]="'assets/icons/help.svg' | s3Image"
							alt="help"
							class="help"
							matTooltipPosition="left"
							matTooltip="{{ locale.translations['ads']['ad']['n639'] }}"
						/>
					</li>
				</ul>
			</div>
		</div>

		<div class="mdc-layout-grid__cell--span-12">
			<div class="mdc-layout-grid__cell--span-12 d-flex flex-column flex-sm-row center justify-content-center">
				<button
					mat-stroked-button
					class="btn-margin btn-border n122 fw-400 w-100"
					[ngClass]="{ 'w-50': viewport.type !== 'mobile' }"
					color="primary"
					[routerLink]="id ? ['/ad/' + id] : ['.']"
				>
					{{ locale.translations['place-ad']['place-ad-success']['n122'] }}
				</button>

				<button
					mat-flat-button
					color="primary"
					[routerLink]="['/user/' + user['userID'] + '/ads']"
					class="n122 fw-400 boost-ad w-100"
					[ngClass]="{ 'w-50': viewport.type !== 'mobile', 'mt-3': viewport.type === 'mobile' }"
				>
					<span>{{ locale.translations['ads']['ad']['n638'] }}</span>
				</button>
			</div>
		</div>
	</div>
</div>
